import { combineReducers } from "redux"
import CommonReducer from "./common/reducer"

const reducer = combineReducers({
	common: CommonReducer,
})

export default reducer
